<template>
    <Card class="card">
        <template #title>
            Members
            <Button icon="pi pi-times" class="p-button-rounded p-button-secondary p-button-text"
                style="position:fixed;right:10px" @click="close()" aria-label="Close" />
        </template>
        <template #content>

            <TabView v-model:activeIndex="activeIndex">
                <TabPanel v-if="getCurrentProject?.projectTitle">
                    <template #header>
                        <span>Project Members</span>
                        <i class="pi pi-question-circle" style="padding-left:5px" v-tooltip.bottom="{
                            value: `Members in current opened project
                            Project Admin
                            - add/remove member
                            - edit project
                            - save as new project
                            - delete project
                            - view project
                            Project Member
                            - edit project
                            - save as new project
                            - view project
                            Project Readonly Member
                            - view project
                            `,
                            escape: true
                        }">
                        </i>
                    </template>
                    <div class="topBar">
                        <span class="p-input-icon-left" style="width:20%;">
                            <i class="pi pi-search" />
                            <InputText v-model="searchMember" placeholder="Search" style="width:100%">
                            </InputText>
                        </span>
                        <Button label="Add member" icon="pi pi-plus" @click="showAddMemberDialog = true"
                            v-if="currentUser?.projectRole == 'Admin'"></Button>
                    </div>
                    <DataTable
                        :value="searchMember ? projectMembers.filter(m => m.name.toLowerCase().includes(searchMember.trim().toLowerCase()) || m.email.toLowerCase().includes(searchMember.trim().toLowerCase())) : projectMembers"
                        :scrollable="true" scrollHeight="350px">
                        <template #empty> No project opened. </template>
                        <Column field="username" header="Username" style="max-width:15%"></Column>
                        <Column field="email" header="Email" style="max-width:40%"></Column>
                        <Column field="phone" header="Phone Number" style="max-width:20%"></Column>
                        <Column field="projectRole" header="Role" style="max-width:20%">
                            <template #body="slotProps">
                                <label
                                    v-if="(slotProps.data.approved && currentUser.projectRole != 'Admin') || slotProps.data.id == currentUser.id"
                                    style="line-height: 28px;">{{ slotProps.data.projectRole }}</label>
                                <div v-else-if="slotProps.data.approved && currentUser.projectRole == 'Admin'">
                                    <Dropdown style="height: 28px;width:100px" v-model="slotProps.data.projectRole"
                                        :options="['Admin', 'Member', 'Readonly']"
                                        @change="updateMemberRole(slotProps.data)">
                                    </Dropdown><i class="pi pi-spin pi-spinner"
                                        v-show="slotProps.data.roleUpdating"></i>
                                </div>
                            </template>
                        </Column>
                        <Column header="" style="max-width:50px">
                            <template #body="slotProps">
                                <Button :icon="slotProps.data.projectDeleting"
                                    class="p-button-rounded p-button-danger p-button-text"
                                    @click="deleteMember(slotProps.data)" v-tooltip="'Remove'"
                                    v-show="currentUser.projectRole == 'Admin' && slotProps.data.projectRole != 'Admin'" />
                            </template>
                        </Column>
                    </DataTable>
                </TabPanel>
                <TabPanel>
                    <template #header>
                        <span>Organization Members</span>
                        <i class="pi pi-question-circle" style="padding-left:5px" v-tooltip.bottom="{
                            value: `Members in your organization
                           Organization Admin
                            - add/remove organization member
                            - add/remove project member
                            - edit personal information
                            Organization Member
                            - edit personal information
                            `,
                            escape: true
                        }">
                        </i>
                    </template>
                    <div class="topBar">
                        <span class="p-input-icon-left" style="width:20%;">
                            <i class="pi pi-search" />
                            <InputText v-model="searchMember" placeholder="Search" style="width:100%">
                            </InputText>
                        </span>
                    </div>
                    <DataTable
                        :value="searchMember ? organizationMembers.filter(m => m.username.toLowerCase().includes(searchMember.trim().toLowerCase()) || m.email.toLowerCase().includes(searchMember.trim().toLowerCase())) : organizationMembers"
                        :scrollable="true" scrollHeight="350px">
                        <Column field="username" header="Username" style="max-width:15%"></Column>
                        <Column field="email" header="Email" style="max-width:40%"></Column>
                        <Column field="phone" header="Phone Number" style="max-width:20%"></Column>
                        <Column field="role" header="Role" style="max-width:20%">
                            <template #body="slotProps">
                                <label
                                    v-if="(slotProps.data.approved && currentUser.role != 'Admin') || slotProps.data.id == currentUser.id"
                                    style="line-height: 28px;">{{ slotProps.data.role }}</label>
                                <div v-else-if="slotProps.data.approved && currentUser.role == 'Admin'">
                                    <Dropdown aria-label="User Role" style="height: 28px;width:100px"
                                        v-model="slotProps.data.role" :options="['Admin', 'Member']"
                                        @change="updateUserRole(slotProps.data)">
                                    </Dropdown><i class="pi pi-spin pi-spinner"
                                        v-show="slotProps.data.roleUpdating"></i>
                                </div>
                                <div
                                    v-else-if="!slotProps.data.approved && currentUser.role == 'Admin' && !slotProps.activating">
                                    <Button icon="pi pi-check" aria-label="Approve"
                                        class="p-button-rounded p-button-secondary p-button-text"
                                        @click="activateUser(slotProps.data)" v-tooltip="'Approve'" />
                                    <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-text"
                                        @click="removeUser(slotProps.data)" aria-label="Reject" v-tooltip="'Reject'" />
                                </div>
                                <i class="pi pi-spin pi-spinner"
                                    v-else-if="!slotProps.data.approved && currentUser.role == 'Admin' && slotProps.activating"></i>
                                <label v-else-if="!slotProps.data.approved && currentUser.role != 'Admin'"
                                    style="line-height: 28px;">Pending Approval</label>
                            </template>
                        </Column>
                        <Column header="" style="max-width:50px">
                            <template #body="slotProps">
                                <Button :icon="slotProps.data.deleting"
                                    class="p-button-rounded p-button-danger p-button-text"
                                    @click="removeUser(slotProps.data)" aria-label="Remove" v-tooltip="'Remove'"
                                    v-show="currentUser.role == 'Admin' && slotProps.data.role != 'Admin'" />
                            </template>
                        </Column>
                    </DataTable>
                </TabPanel>
            </TabView>
        </template>
    </Card>
    <Dialog v-model:visible="showAddMemberDialog" modal :header="`Add member to ${getCurrentProject?.projectTitle}`"
        :style="{ width: '30vw' }">
        <p>
            Start typing an email to add to your project. You can also add people outside your organization
            by
            typing
            their
            email
            addresses.
        </p>
        <div style="display: flex;margin-bottom: 10px;">
            <AutoComplete v-model="membersToAdd" multiple placeholder="Start typing an email" :suggestions="members"
                style="margin-right: 10px;" aria-label="Email" @complete="search($event)" optionLabel="email">
                <template #option="slotProps">
                    <div>{{ slotProps.option.username }}</div>
                    <div>{{ slotProps.option.email }}</div>
                    <div>{{ slotProps.option.company }}</div>
                </template>
            </AutoComplete>
            <Button v-if="!adding" label="Add" aria-label="Add" @click="addMembers" style="width:70px"
                :disabled="!membersToAdd.length"></Button>
            <Button v-if="adding" icon="pi pi-spin pi-spinner" label="Add" @click="addMembers" style="width:70px"
                :disabled="true"></Button>
        </div>
        <DataTable v-if="newAddedMembers.length" :value="newAddedMembers" :scrollable="true" scrollHeight="200px"
            style="height:200px">
            <Column field="username" header="Username" style="max-width:30%"></Column>
            <Column field="company" header="Organization" style="max-width:50%"></Column>
            <Column field="projectRole" header="Role" style="max-width:20%">
                <template #body="slotProps">
                    <div>
                        <Dropdown style="height: 28px;width:100px" v-model="slotProps.data.projectRole"
                            :options="['Admin', 'Member', 'Readonly']" @change="updateMemberRole(slotProps.data)">
                        </Dropdown><i class="pi pi-spin pi-spinner" v-show="slotProps.data.roleUpdating"></i>
                    </div>
                </template>
            </Column>
        </DataTable>
        <div v-if="!newAddedMembers.length" style="height:200px"></div>
        <template #footer>
            <Button label="Close" @click="showAddMemberDialog = false" autofocus style="width:70px" />
        </template>
    </Dialog>
</template>

<script>
import { ref, reactive } from 'vue';

export default {
    name: 'MembersView',
    data() {
        return {
            projectMembers: [],
            organizationMembers: [],
            currentUser: null,
            showAddMemberDialog: false,
            searchMember: "",
            membersToAdd: [],
            members: [],
            newAddedMembers: [],
            adding: false
        }
    },
    computed: {
        getCurrentProject() {
            return this.$store.getters.currentProject
        }
    },
    methods: {
        getCurrentUser() {
            return this.$store.getters.currentUser;
        },
        getProjectMembers(project) {
            let currentProject = project ? project : this.$store.getters.currentProject
            console.log(currentProject)
            if (currentProject?.id) {
                this.projectMembers = [
                    ...this.initProjectMember(currentProject.adminUsers || [], "Admin"),
                    ...this.initProjectMember(currentProject.memberUsers || [], "Member"),
                    ...this.initProjectMember(currentProject.readonlyUsers || [], "Readonly")
                ]
            }
        },
        initProjectMember(members, role) {
            return members.map(m => {
                return {
                    ...m,
                    name: `${m.firstName} ${m.lastName}`,
                    projectRole: role,
                    roleUpdating: false,
                    projectDeleting: "pi pi-trash"
                }
            })
        },
        getCurrentUserProjectRole() {
            let currentProject = this.$store.getters.currentProject;
            if (currentProject?.id) {
                if (currentProject.adminUserIds.includes(this.currentUser.id)) {
                    this.currentUser.projectRole = "Admin"
                }
                else if (currentProject.memberUserIds.includes(this.currentUser.id)) {
                    this.currentUser.projectRole = "Member"
                }
                else if (currentProject.readonlyUserIds.includes(this.currentUser.id)) {
                    this.currentUser.projectRole = "Readonly"
                }
            }
        },
        getOrganizationMembers() {
            let props = this;
            this.axios
                .get(`${this.apiEndpoint}user?company=${this.getCurrentUser().company}`)
                .then(response => {
                    response.data.forEach(m => {
                        m.name = `${m.firstName} ${m.lastName}`;
                        m.role = m.userType.replace("Contractor ", "");
                        m.roleUpdating = false;
                        m.activating = false;
                        m.deleting = "pi pi-trash";
                    })
                    props.organizationMembers = response.data.sort((a, b) => (a.userType + a.username.toLowerCase() > b.userType + b.username.toLowerCase()) ? 1 : -1);
                })
        },
        updateUserRole(user) {
            user.roleUpdating = true;
            this.axios
                .post(`${this.apiEndpoint}user?role=${user.role}`, user)
                .then(response => {
                    user.roleUpdating = false;
                })
                .catch((error) => {
                    console.log(error);
                    user.roleUpdating = false;
                })
        },
        activateUser(user) {
            user.activating = true;
            this.axios
                .post(`${this.apiEndpoint}user/activate?id=${user.id}&activate=true`)
                .then(response => {
                    user.approved = true;
                    user.activating = false;
                })
                .catch((error) => {
                    console.log(error);
                    user.activating = false;
                })
        },
        removeUser(user) {
            let props = this;
            user.deleting = "pi pi-spin pi-spinner";
            this.axios
                .delete(`${this.apiEndpoint}user?guid=${user.guid}`)
                .then(response => {
                    let index = props.organizationMembers.indexOf(user);
                    if (index > -1) {
                        props.organizationMembers.splice(index, 1);
                    }
                    user.deleting = "pi pi-trash";
                })
                .catch((error) => {
                    console.log(error);
                    user.deleting = "pi pi-trash";
                })
        },
        search(event) {
            if (event.query.trim().length) {
                let existingMemberIds = [...this.projectMembers.map(m => m.id), ...this.membersToAdd.map(m => m.id)];
                // if (event.query.trim().includes("@")) {
                this.axios.get(`${this.apiEndpoint}user/search?email=${event.query.trim().toLowerCase()}`)
                    .then(response => {
                        this.members = response.data.filter(d => !existingMemberIds.includes(d.id)).map(d => {
                            return {
                                ...d,
                                name: `${d.firstName} ${d.lastName}`
                            }
                        })
                    })
                // }
                // else {
                //     this.axios.get(`${this.apiEndpoint}user/search?name=${event.query.trim().toLowerCase()}&company=${this.getCurrentUser().company}`)
                //         .then(response => {
                //             this.members = response.data.filter(d => !existingMemberIds.includes(d.id)).map(d => {
                //                 return {
                //                     ...d,
                //                     name: `${d.firstName} ${d.lastName}`
                //                 }
                //             })
                //         })
                // }
            }
        },
        addMembers() {
            this.adding = true;
            this.axios.post(`${this.apiEndpoint}project/members?projectId=${this.$store.getters.currentProject.id}&userIds=${this.membersToAdd.map(u => u.id).join(',')}&role=member`)
                .then(response => {
                    this.newAddedMembers = this.membersToAdd.map(m => {
                        return {
                            ...m,
                            projectRole: "Member",
                            projectDeleting: "pi pi-trash"
                        }
                    })
                    this.$store.dispatch('setCurrentProject', {
                        project: {
                            ...this.$store.getters.currentProject,
                            adminUsers: response.data.adminUsers,
                            memberUsers: response.data.memberUsers,
                            readonlyUsers: response.data.readonlyUsers,
                            adminUserIds: response.data.adminUserIds,
                            memberUserIds: response.data.memberUserIds,
                            readonlyUserIds: response.data.readonlyUserIds,
                        }
                    });
                    this.getProjectMembers(response.data);
                    this.membersToAdd = [];
                    this.adding = false;
                })
        },
        updateMemberRole(member) {
            member.roleUpdating = true;
            this.axios.post(`${this.apiEndpoint}project/members?projectId=${this.$store.getters.currentProject.id}&userIds=${member.id}&role=${member.projectRole.toLowerCase()}`)
                .then(response => {
                    member.roleUpdating = false;
                    this.$store.dispatch('setCurrentProject', {
                        project: {
                            ...this.$store.getters.currentProject,
                            adminUsers: response.data.adminUsers,
                            memberUsers: response.data.memberUsers,
                            readonlyUsers: response.data.readonlyUsers,
                            adminUserIds: response.data.adminUserIds,
                            memberUserIds: response.data.memberUserIds,
                            readonlyUserIds: response.data.readonlyUserIds,
                        }
                    });
                    this.getProjectMembers(response.data);
                })
        },
        deleteMember(member) {
            member.projectDeleting = "pi pi-spin pi-spinner";
            this.axios.delete(`${this.apiEndpoint}project/members?projectId=${this.$store.getters.currentProject.id}&userId=${member.id}`)
                .then(response => {
                    member.projectDeleting = "pi pi-trash";
                    this.$store.dispatch('setCurrentProject', {
                        project: {
                            ...this.$store.getters.currentProject,
                            adminUsers: response.data.adminUsers,
                            memberUsers: response.data.memberUsers,
                            readonlyUsers: response.data.readonlyUsers,
                            adminUserIds: response.data.adminUserIds,
                            memberUserIds: response.data.memberUserIds,
                            readonlyUserIds: response.data.readonlyUserIds,
                        }
                    });
                    this.getProjectMembers(response.data);
                })
        },
        close() {
            this.$router.replace({ path: '/' });
        }
    },
    mounted() {
        this.getProjectMembers();
        this.getOrganizationMembers();
        this.currentUser = this.getCurrentUser();
        this.currentUser.role = this.currentUser.userType.replace("Contractor ", "");
        this.getCurrentUserProjectRole();
    }
}
</script>

<style scoped>
.card {
    width: 40vw;
    position: absolute;
    transform: translate(75%, 10%);
}

.topBar {
    display: flex;
    justify-content: space-between;
    height: 30px;
    margin-bottom: 10px;
    flex-direction: row-reverse;
}
</style>

<style>
.tooltipTitle {
    font-weight: bold;
}

.marginLeft {
    margin-left: 10px;
}

.p-autocomplete {
    width: 100%;
}

.p-autocomplete-multiple-container {
    width: 100% !important;
}

.p-autocomplete-input-token>input {
    width: 90% !important;
}
</style>